/**
 * PostgREST API
 * This is a dynamic API generated by PostgREST
 *
 * The version of the OpenAPI document: 11.2.0 (c820efb)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserContactInformation { 
    /**
     * Note: This is a Primary Key.<pk/>
     */
    id: string;
    display_name?: string;
    contact_email?: string;
    contact_phone?: string;
}

